import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/content/templates")({
  component: () => (
    <Breadcrumb label="Templates" to="/content/templates">
      <Outlet />
    </Breadcrumb>
  ),
});
